/** Transporte exclusivo a API Cloud Run para exportaciones CSV.
 * Nunca enviar el token por querystring (GAS/JSONP).
 */
const BASE = (import.meta.env.VITE_GICAPITAL_API_BASE_URL || 'https://api.gicapital.cl').replace(/\/$/, '');
const PATH = '/api/v1/private/kommo-history';
async function request(path, token, options = {}) {
  if (!token) throw new Error('Iniciá sesión antes de exportar');
  const response = await fetch(BASE + PATH + path, {
    ...options,
    headers: { Authorization: 'Bearer ' + token, ...(options.body ? { 'Content-Type': 'application/json' } : {}) },
    cache: 'no-store',
  });
  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    if (response.status === 401 || response.status === 403) {
      throw new Error('Tu usuario de Analytics no tiene acceso de administrador en la API. Revisa las autorizaciones Firebase.');
    }
    if (data.error === 'direct_export_limit') {
      throw new Error(data.message || 'La consulta directa es demasiado grande; usá un período o la copia Firestore.');
    }
    if (data.error === 'kommo_direct_export_failed') {
      throw new Error('Kommo no pudo completar la descarga directa. Reintentá más tarde.');
    }
    if (data.error === 'backfill_incomplete') {
      throw new Error('La sincronización histórica todavía no terminó. Continuá la sincronización antes de exportar.');
    }
    throw new Error(data.error || 'Error HTTP ' + response.status);
  }
  return response;
}
export async function getKommoHistoryStatus(token) {
  return (await request('/status', token)).json();
}
export async function syncKommoHistoryPage(token) {
  return (await request('/sync', token, { method: 'POST', body: JSON.stringify({ maxPages: 2 }) })).json();
}
/** Descarga autenticada sin exponer datos privados en la URL del navegador. */
export async function downloadKommoHistory(token, format, filter, source = 'firestore') {
  if (!['leads', 'stages'].includes(format)) throw new Error('Formato incorrecto');
  if (!['firestore', 'kommo'].includes(source)) throw new Error('Origen de descarga incorrecto');
  const q = new URLSearchParams();
  q.set('scope', filter.scope);
  if (filter.scope === 'created_between') {
    q.set('from', filter.from);
    q.set('to', filter.to);
  }
  const apiPath = source === 'kommo' ? '/export-direct/' : '/export/';
  const response = await request(apiPath + format + '?' + q.toString(), token);
  const blob = await response.blob();
  const objectUrl = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = objectUrl;
  const label = source === 'kommo' ? 'kommo-directo' : 'base-gicapital';
  link.download = format === 'leads' ? label + '-leads.csv' : label + '-historial-etapas.csv';
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(objectUrl), 30_000);
}
